import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { GoalDetailHeader } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/GoalDetailHeader';

const PayOffDebtLayout = () => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  return (
    <FDStack direction="column" spacing={2} alignItems="center" width={'100%'}>
      <GoalDetailHeader />
      <MetaControlField attr={'debtPayOffPreference'} />
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
};

PayOffDebtLayout.defaultProps = {};

PayOffDebtLayout.propTypes = {};

export { PayOffDebtLayout };
